export interface ConnectRedirectOptions {
  appId: string;
  routePath?: string;
  connectUrl?: string;
}

const CONNECT_URL_STORAGE_KEY = 'formica.connect.url';
const DEFAULT_DEV_CONNECT_PORT = '5173';

function viteEnvValue(key: string): string {
  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
  return env?.[key] || '';
}

function normalizeHashPath(path: string): string {
  const trimmed = (path || '/').trim();
  if (!trimmed || trimmed === '#') return '/';
  const withoutHash = trimmed.startsWith('#') ? trimmed.slice(1) : trimmed;
  return withoutHash.startsWith('/') ? withoutHash : `/${withoutHash}`;
}

function defaultConnectOrigin(): string {
  if (typeof window === 'undefined') return '';

  const { hostname, origin, protocol } = window.location;
  const isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname === '[::1]';

  if (isLocal && window.location.port !== DEFAULT_DEV_CONNECT_PORT) {
    return `${protocol}//${hostname}:${DEFAULT_DEV_CONNECT_PORT}`;
  }

  return origin;
}

function readConfiguredConnectUrl(): string {
  if (typeof window === 'undefined') return '';

  return (
    viteEnvValue('VITE_CONNECT_URL') ||
    window.localStorage.getItem(CONNECT_URL_STORAGE_KEY) ||
    defaultConnectOrigin()
  ).replace(/\/+$/, '');
}

export function connectAppPath(appId: string, routePath = '/'): string {
  const normalizedRoute = normalizeHashPath(routePath);
  const prefix = `/${appId.replace(/^\/+|\/+$/g, '')}`;
  return normalizedRoute === '/' ? prefix : `${prefix}${normalizedRoute}`;
}

export function buildConnectRedirectUrl(options: ConnectRedirectOptions): string {
  const connectUrl = (options.connectUrl || readConfiguredConnectUrl()).replace(/\/+$/, '');
  const path = connectAppPath(options.appId, options.routePath);
  const search = typeof window !== 'undefined' ? window.location.search : '';
  return `${connectUrl}/${search}#${path}`;
}

export function redirectStandaloneAppToConnect(options: ConnectRedirectOptions): false {
  if (typeof window === 'undefined') return false;
  window.location.replace(buildConnectRedirectUrl(options));
  return false;
}
